<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0303 3.03033C18.3232 2.73744 18.3232 2.26256 18.0303 1.96967C17.7374 1.67678 17.2626 1.67678 16.9697 1.96967L17.5 2.5L18.0303 3.03033ZM10.7197 8.21967C10.4268 8.51256 10.4268 8.98744 10.7197 9.28033C11.0126 9.57322 11.4874 9.57322 11.7803 9.28033L11.25 8.75L10.7197 8.21967ZM17.5 2.5L16.9697 1.96967L10.7197 8.21967L11.25 8.75L11.7803 9.28033L18.0303 3.03033L17.5 2.5Z"
      fill="currentcolor"
    />
    <path
      d="M9.28033 11.7803C9.57322 11.4874 9.57322 11.0126 9.28033 10.7197C8.98744 10.4268 8.51256 10.4268 8.21967 10.7197L8.75 11.25L9.28033 11.7803ZM1.96967 16.9697C1.67678 17.2626 1.67678 17.7374 1.96967 18.0303C2.26256 18.3232 2.73744 18.3232 3.03033 18.0303L2.5 17.5L1.96967 16.9697ZM8.75 11.25L8.21967 10.7197L1.96967 16.9697L2.5 17.5L3.03033 18.0303L9.28033 11.7803L8.75 11.25Z"
      fill="currentcolor"
    />
    <path
      d="M14.582 8.94613C13.8784 8.95613 11.548 9.44023 11.0539 8.94613C10.5598 8.45203 11.0439 6.12164 11.0539 5.41797"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M8.94613 14.582C8.95613 13.8784 9.44023 11.548 8.94613 11.0539C8.45203 10.5598 6.12164 11.0439 5.41797 11.0539"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
